<template>
  <div class="hero-text-placeholder">
    <content-loader
      class="d-none d-md-block"
      primary-color="#ffffff"
      secondary-color="#cccccc"
      :primary-opacity="0.6"
      :secondary-opacity="0.5"
      width="1184"
      height="195"
    >
      <rect x="0" y="5" rx="0" ry="0" width="480" height="39" />
      <rect x="0" y="49" rx="0" ry="0" width="235" height="39" />
      <rect x="604" y="0" rx="0" ry="0" width="680" height="16" />
      <rect x="604" y="20" rx="0" ry="0" width="680" height="16" />
      <rect x="604" y="40" rx="0" ry="0" width="680" height="16" />
      <rect x="604" y="60" rx="0" ry="0" width="680" height="16" />
      <rect x="604" y="80" rx="0" ry="0" width="680" height="16" />
      <rect x="604" y="100" rx="0" ry="0" width="680" height="16" />
      <rect x="604" y="120" rx="0" ry="0" width="680" height="16" />
      <rect x="604" y="140" rx="0" ry="0" width="680" height="16" />
      <rect x="604" y="160" rx="0" ry="0" width="680" height="16" />
      <rect x="604" y="180" rx="0" ry="0" width="300" height="16" />
      <rect x="0" y="136" rx="30" ry="30" width="166" height="58" />
    </content-loader>
    <content-loader
      class="mt-1 d-md-none"
      primary-color="#ffffff"
      secondary-color="#cccccc"
      :primary-opacity="0.6"
      :secondary-opacity="0.5"
      :width="width"
      :height="totalHeight"
    >
      <rect
        v-for="hr in headingRows"
        :key="hr + 100"
        x="0"
        :y="getHeadingRowPosition(hr)"
        :width="getRowWidth(hr === headingRows, 0.25)"
        :height="headingRowHeight"
      />

      <rect
        v-for="tr in textRows"
        :key="tr + 200"
        x="0"
        :y="getTextRowPosition(tr)"
        :width="getRowWidth(tr === textRows, 0.75)"
        :height="textRowHeight"
      />

      <rect :x="width / 2 - buttonWidth / 2" :y="headingHeight + textHeight" rx="30" ry="30" :width="buttonWidth" :height="buttonHeight" />
    </content-loader>
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { ContentLoader } from "vue-content-loader";

defineOptions({
  name: "currently-on-ersties-text-placeholder",
});

const width = ref(window.innerWidth);
const headingRows = 2;
const headingRowHeight = 28;
const headingGap = 6;
const headingBottomGap = 16;
const textRows = 10;
const textRowHeight = 20;
const textGap = 6;
const textBottomGap = 40;
const buttonHeight = 58;

const buttonWidth = computed(() => {
  return width.value > 300 ? 300 : width.value;
});

const headingHeight = computed(() => {
  return (headingRowHeight + headingGap) * headingRows + headingBottomGap;
});

const textHeight = computed(() => {
  return (textRowHeight + textGap) * textRows + textBottomGap;
});

const totalHeight = computed(() => {
  return headingHeight.value + textHeight.value + buttonHeight;
});

function getHeadingRowPosition(index: number) {
  return (index - 1) * (headingGap + headingRowHeight);
}

function getTextRowPosition(index: number) {
  return headingHeight.value + (index - 1) * (textGap + textRowHeight);
}

function getRowWidth(isLast: boolean, length: number = 1) {
  return isLast ? width.value * length : width.value;
}

function onResize() {
  width.value = window.innerWidth;
}

onMounted(() => {
  window.addEventListener("resize", onResize);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", onResize);
});
</script>
